export default __webpack_public_path__ + "static/media/Viridian Arrows.1c842524.jpg";